if (!customElements.get('wwd-announcement-rotator')) {
  customElements.define('wwd-announcement-rotator', class extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('.announcement')];
      if (this.messages.length < 2 || this.timer) return;
      this.index = 0;
      this.timer = setInterval(() => {
        if (document.hidden || this.matches(':hover, :focus-within')) return;
        this.messages[this.index].classList.remove('is-active');
        this.messages[this.index].setAttribute('aria-hidden', 'true');
        this.index = (this.index + 1) % this.messages.length;
        this.messages[this.index].classList.add('is-active');
        this.messages[this.index].setAttribute('aria-hidden', 'false');
      }, 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
    }
  });
}
